import {
  DvFormElementParams,
  DvSpaceElement,
  DvSpaceElementParams,
  FormType,
} from '@devinco/ui/dds';
import { FormElementExtra } from './form.element';

export class VtSpaceElement<
  TForm extends FormType = FormType,
  TFormContext = any,
> extends DvSpaceElement<TForm> {
  constructor(params: VtSpaceElementParams<TForm, TFormContext>) {
    super(params);
    params.elementParams ??= {};
    params.extra ??= {};
  }
}

export interface VtSpaceElementParams<
  TForm extends FormType,
  TFormContext = any,
> extends DvFormElementParams<{
  TForm: TForm;
  TFormContext: TFormContext;
  TElementParams: DvSpaceElementParams;
}> {
  extra?: FormElementExtra;
}
